import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const LabelKindUser = hoc(
    (props: IconProps) => (
        <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle cx={8} cy={8} r={8} fill="#4BB24E" />
            <path
                d="M11.3333 11.75V10.9167C11.3333 10.4746 11.1577 10.0507 10.8451 9.73816C10.5326 9.4256 10.1087 9.25 9.66663 9.25H6.33329C5.89127 9.25 5.46734 9.4256 5.15478 9.73816C4.84222 10.0507 4.66663 10.4746 4.66663 10.9167V11.75M9.66663 5.91667C9.66663 6.83714 8.92043 7.58333 7.99996 7.58333C7.07948 7.58333 6.33329 6.83714 6.33329 5.91667C6.33329 4.99619 7.07948 4.25 7.99996 4.25C8.92043 4.25 9.66663 4.99619 9.66663 5.91667Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    'Label'
);
export default LabelKindUser;
